import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#let (unique-id) as |id|}}\n  <div class={{this.class}} {{fui-checkbox this.settings}}>\n    <input id={{id}} type={{this.type}} checked={{@checked}} />\n    <label for={{id}}>{{@label}}</label>\n  </div>\n{{/let}}", {
  moduleName: "core/components/fui-checkbox/index.hbs"
});